import { useCallback } from "react";

export const useOnMethodDeleted = (
  items: any,
  selectedItem: string,
  setItems: React.Dispatch<React.SetStateAction<any>>,
  setSelectedItem: React.Dispatch<React.SetStateAction<string>>,
) => {
  const onDeleted = useCallback(
    (id: string) => {
      const values: any[] = items.filter((item: any) => item.id !== id);

      setItems(values);

      if (selectedItem === id) {
        setSelectedItem(values[0].id);
      }
    },
    [items, selectedItem, setItems, setSelectedItem],
  );

  return { onDeleted };
};
